import React from "react";
import { Button, Input } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import { MAX_LINES, emptyLine, previewText } from "./taxMath";

/**
 * Up to three taxes, each a name and a percentage ("GST" 5, "PST" 7) — one row
 * per tax on the receipt. Controlled: `value` is [{label, percent}].
 *
 * `allowNone`: a practice or office may be tax-exempt (no lines). The default and
 * the provinces always tax.
 */
export default function TaxLinesEditor({ value, onChange, allowNone = false }) {
  const lines = value || [];
  const set = (i, patch) => onChange(lines.map((line, j) => (j === i ? { ...line, ...patch } : line)));
  const preview = lines.length ? previewText(lines) : "";

  return (
    <div className="ub-tax-lines">
      {lines.map((line, i) => (
        <div className="ub-tax-line" key={i}>
          <Input
            placeholder="Name, e.g. GST"
            value={line.label}
            maxLength={20}
            onChange={(e) => set(i, { label: e.target.value })}
            style={{ width: 170 }}
          />
          <Input
            placeholder="Rate"
            value={line.percent}
            suffix="%"
            inputMode="decimal"
            onChange={(e) => set(i, { percent: e.target.value })}
            style={{ width: 120 }}
          />
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            aria-label="Remove this tax"
            disabled={!allowNone && lines.length === 1}
            onClick={() => onChange(lines.filter((_, j) => j !== i))}
          />
        </div>
      ))}
      {lines.length < MAX_LINES ? (
        <Button size="small" type="link" icon={<PlusOutlined />} style={{ padding: 0 }}
                onClick={() => onChange([...lines, emptyLine()])}>
          Add a tax
        </Button>
      ) : null}
      <div className="leadset-hint">
        {lines.length ? preview : "No sales tax — charges are tax-exempt."}
      </div>
    </div>
  );
}
